import React from "react";

import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import useResponsiveFlags from "../../hooks/useResponsiveFlags";

export default function AgreementTableHead(props) {
  const { order, orderBy, onSort } = props;
  const { isSmallMobileScreen } = useResponsiveFlags();
  return (
    <TableHead>
      <TableRow>
        <TableCell
          style={
            !isSmallMobileScreen
              ? {
                  position: "sticky",
                  top: 0,
                  left: 0,
                  zIndex: 11,
                }
              : {}
          }
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <span className="storage-limit" style={{ marginRight: "8px" }}>
              Organizations
            </span>
            <SortingIcon
              order={order}
              active={orderBy === "org"}
              onClick={() => onSort("org")}
            />
          </div>
        </TableCell>
        
        <TableCell style={{ minWidth: "126.5px" }}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <span className="storage-limit" style={{ marginRight: "8px" }}>
              Agreement Type
            </span>

            <SortingIcon
              order={order}
              active={orderBy === "agreement_type"}
              onClick={() => onSort("agreement_type")}
            />
          </div>
        </TableCell>
        <TableCell>
          <div
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <span className="storage-limit" style={{ marginRight: "8px" }}>
              User
            </span>

            <SortingIcon
              order={order}
              active={orderBy === "user"}
              onClick={() => onSort("user")}
            />
          </div>
        </TableCell>
        
        <TableCell style={{ minWidth: "134px" }}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <span className="storage-limit" style={{ marginRight: "8px" }}>
              Type
            </span>

            <SortingIcon
              order={order}
              active={orderBy === "type"}
              onClick={() => onSort("type")}
            />
          </div>
        </TableCell>
        <TableCell style={{ minWidth: "109.5px" }}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <span className="storage-limit" style={{ marginRight: "8px" }}>
              Year
            </span>

            <SortingIcon
              order={order}
              active={orderBy === "year"}
              onClick={() => onSort("year")}
            />
          </div>
        </TableCell>
        <TableCell style={{ minWidth: "109.5px" }}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <span className="storage-limit" style={{ marginRight: "8px" }}>
              Status
            </span>

            <SortingIcon
              order={order}
              active={orderBy === "status"}
              onClick={() => onSort("status")}
            />
          </div>
        </TableCell>
        <TableCell>
          <div
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <span className="storage-limit" style={{ marginRight: "8px" }}>
              Signed
            </span>
          </div>
        </TableCell>
        <TableCell style={{ minWidth: "97px" }}>
          <span className="storage-limit" style={{ marginRight: "8px" }}>
            Action
          </span>
        </TableCell>
        <TableCell style={{ minWidth: "240px" }}>
          <span className="storage-limit" style={{ marginRight: "8px" }}>
            Agreement ID
          </span>
        </TableCell>
        
      </TableRow>
    </TableHead>
  );
}

function SortingIcon({ order, active, onClick }) {
  return (
    <span
      onClick={onClick}
      style={{
        cursor: "pointer",
        display: "inline-flex",
        flexDirection: "column",
        //   alignItems: "center",
        //   marginLeft: "5px",
      }}
    >
      <span
        style={{
          color: active && order === "asc" ? "#000" : "#ccc",
          fontSize: "0.5rem",
          lineHeight: "0.5rem",
        }}
      >
        ▲
      </span>
      <span
        style={{
          color: active && order === "desc" ? "#000" : "#ccc",
          fontSize: "0.5rem",
          lineHeight: "0.5rem",
        }}
      >
        ▼
      </span>
    </span>
  );
}
